import styled from 'styled-components';
import { mediaQuery } from 'modules/utils';
import { theme } from 'modules/ui/theme';
import { Button } from 'modules/ui/button';

export const StyledTableHead = styled.thead`
  display: none;
  background-color: ${({theme}) => theme.colors.primaryK8};

  ${mediaQuery('md')} {
    display: table-header-group;
    background-color: ${({theme}) => theme.colors.primaryK8};
  }
`;

export const StyledCellContentContainer = styled.div<{
  columnsMaxWidth?: string;
}>`
  ${(props) =>
    props.columnsMaxWidth ? `max-width: ${props.columnsMaxWidth}` : ''};

  ${mediaQuery('md')} {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
`;

export const StyledSortButton = styled(Button)<{
  mobileOnly?: boolean;
  sorted?: boolean;
}>`
  display: none;

  ${mediaQuery('md')} {
    display: flex;
    & > div {
      white-space: normal;
      text-align: left;
      color: ${({theme}) => theme.colors.primaryK10} !important;
    }
  }
  
  svg {
    width: 0.875rem;
    color: ${({theme}) => theme.colors.primaryK10};
  }
`;

export const StyledLabel = styled.span<{
  mobileOnly?: boolean;
}>`
  display: inline;

  ${mediaQuery('md')} {
    ${(props) => (props.mobileOnly ? 'display: none' : '')};
  }

  font-weight: ${theme.fontWeight.bold};
  font-size: var(--h5-font-size);
  line-height: var(--h5-line-height);
  color: ${({theme}) => theme.colors.primaryK10};
  text-transform: uppercase;
  user-select: none;
`;
